<template>
  <b-button
    :class="className"
    :variant="variant"
    :disabled="disabled"
    @click="$emit('handle-click', $event)"
    @mouseover="$emit('handle-mouseover')"
    @mouseleave="$emit('handle-mouseleave')"
    class="default"
    :type="type"
  >
    <img src="@/assets/img/copy.svg" v-if="copy" class="copy-icon" />
    <img
      src="@/assets/img/logo-white.svg"
      v-if="showLogo && !loader"
      class="button-image"
    />
    <b-spinner v-else-if="loader" label="loading" class="button-loader" />
    <span v-if="!loader">{{ name }}</span>
    <span v-else>Processing...</span>
    <img
      src="@/assets/img/right-arrow-blue.svg"
      v-if="ssoScreen"
      class="svg button-arrow-image"
    />
  </b-button>
</template>
<script>
import { BButton, BSpinner } from "bootstrap-vue";

export default {
  name: "CustomButton",
  components: {
    BButton,
    BSpinner,
  },
  props: {
    className: String,
    variant: String,
    disabled: Boolean,
    name: String,
    loader: Boolean,
    copy: {
      type: Boolean,
      default: false,
    },
    showLogo: {
      type: Boolean,
      default: false,
    },
    ssoScreen: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss">
.copy-icon {
  width: 20px;
}
.default {
  position: relative;
  transition: transform 0.12s ease;

  &:not(:disabled):active {
    transform: scale(0.98);
  }
}
.button-image {
  display: inline-block;
  position: absolute;
  left: 30px;
  width: 20px;
  height: 20px;
  top: 9px;
}
.button-loader {
  width: 25px !important;
  height: 25px !important;
  display: inline-block;
  position: absolute;
  left: 30px;
  color: #f0833c !important;
}
.button-arrow-image {
  display: inline-block;
  position: absolute;
  right: 20px;
  width: 20px;
  top: 17px;
  transform: rotate(180deg);
  &:hover {
    filter: brightness(0) invert(1);
  }
}
.button-default {
  background-color: var(--button-default-background-color) !important;
  border-color: var(--button-default-background-color) !important;
  color: var(--button-default-text-color);
  &:hover {
    background-color: var(--button-default-background-color) !important;
    border-color: var(--button-default-background-color) !important;
    color: var(--button-default-text-color);
  }
  &:disabled {
    background-color: #ebebeb !important;
    border: 1px solid #ebebeb !important;
    cursor: default;
    font-weight: bold !important;
    color: #fff !important;
  }
}
.button-default-outline {
  background-color: var(--button-default-outline-background-color) !important;
  border-color: var(--button-default-outline-text-color) !important;
  color: var(--button-default-outline-text-color) !important;
  &:hover:not(.connect) {
    background-color: var(--button-default-outline-text-color) !important;
    border-color: var(--button-default-outline-text-color) !important;
    color: var(--button-default-outline-background-color) !important;
  }
}
.button-default-outline.disabled,
.button-default-outline:disabled {
  color: #828ba1 !important;
  background-color: #fff !important;
  border: 1px solid #828ba1 !important;
  cursor: default;
  &:hover {
    background-color: transparent !important;
    .button-arrow-image {
      filter: invert(0.5);
    }
  }
}
.orange-fill {
  background-color: #f0833c !important;
  border-color: #f0833c !important;
  color: #fff;
  &:hover {
    background-color: #e26f02 !important;
    border-color: #e26f02 !important;
  }
  &:disabled {
    background-color: #ebebeb !important;
    border: 1px solid #ebebeb !important;
    cursor: default;
    font-weight: bold !important;
    color: #fff !important;
  }
}
.orange-boundary {
  background-color: #fff !important;
  border-color: #f0833c !important;
  color: #f0833c !important;
  &:hover {
    background-color: #e26f02 !important;
    color: #ebebeb !important;
  }
  &:disabled {
    background-color: #ebebeb !important;
    border: 1px solid #ebebeb !important;
    cursor: default;
    font-weight: bold !important;
    color: #fff !important;
  }
}
.btn-outline-primary {
  &:hover {
    .button-arrow-image {
      filter: brightness(0) invert(1);
    }
  }
}
.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: #828ba1 !important;
  background-color: transparent;
  border: 1px solid #828ba1 !important;
  cursor: default;
  &:hover {
    .button-arrow-image {
      filter: invert(0.5);
    }
  }
}
</style>
